import { getRooftTypes } from 'common/api/core';

import {
    FETCH_ROOF_TYPES,
    FETCH_ROOF_TYPES_FAILURE,
    FETCH_ROOF_TYPES_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_ROOF_TYPES]());

    getRooftTypes()
        .then((response) => {
            const data = response.data.data;
            dispatch(actions[FETCH_ROOF_TYPES_SUCCESS](data));
        })
        .catch((error) =>
            dispatch(
                actions[FETCH_ROOF_TYPES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
